<template>
  <div>
    <tab ref="tab" :tab-list="tabList" class="tab-list" />

    <section class="news-title-wrap">
      <h4 class="news-title">{{ $t('menuNewsroom.press') }}</h4>
      <div class="news-title-sub">{{ $t('press.title') }}</div>
    </section>

    <list-component
      type="report"
      date="DistributeDay"
      page-query="page"
      :size="listSize"
      :prev-route="prevRoute"
      @prevRouteUpdate="prevRouteUpdate"
    />
  </div>
</template>
<script>
import listPosition from '@/mixins/listPostion'
export default {
  components: {
    tab: () => import('@/components/base/Tab'),
    listComponent: () => import('@/components/base/NewsroomList'),
  },
  mixins: [listPosition],
  props: {
    tabList: {
      type: Array,
      default: function () {
        return {
          name: String,
          path: String
        }
      }
    },
    listSize: {
      type: Number,
      default: 10
    }
  },
  data () {
    return {
      prevRoute: null
    }
  },
  methods: {
    prevRouteUpdate (value) {
      this.prevRoute = value
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.prevRoute = from.name
    })
  },
}
</script>
